module.exports =
  views: require './map/views.coffee'
  decisions: require './map/decisions.coffee'
  steps: require './map/steps.coffee'
